module.exports = __webpack_public_path__ + "img/gas.f4cd5c85.png";